import { Routes, Route, Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DemoModeProvider } from './contexts/DemoModeContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import DevConsoleLoader from './components/DevConsoleLoader';
import ChatPage from './pages/ChatPage';
import CallbackPage from './pages/CallbackPage';
import PublicPasswordReset from './pages/PublicPasswordReset';
import LoggedOutPage from './pages/LoggedOutPage';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <DemoModeProvider>
        <Authenticator.Provider>
          <AuthProvider>
            <DevConsoleLoader />
            <Routes>
              {/* Public routes */}
              <Route path="/password-reset" element={<PublicPasswordReset />} />
              <Route path="/callback" element={<CallbackPage />} />
              <Route path="/logged-out" element={<LoggedOutPage />} />

              {/* Protected routes */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ErrorBoundary>
                        <Routes>
                          <Route path="/" element={<ChatPage />} />
                          <Route path="/chat" element={<ChatPage />} />
                          <Route path="/chat/:sessionId" element={<ChatPage />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </ErrorBoundary>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AuthProvider>
        </Authenticator.Provider>
        </DemoModeProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
